import { api } from '@/services/api'
import { ServiceRFQs } from '@/services/RFQs'
import { SET, PUSH, MERGE, MERGE_ARRAY, DELETE_ITEM_ARRAY, MERGE_ITEM_ARRAY, UPDATE } from '@/plugins/store/mutationTypes'
import { getDefaultPO } from '@/utils/shared'

let stepIndexList = [1, 2, 3, 4]
const state = {
  isLoading: false,
  dataRFQ: {},
  listRFQ1: [],
  listRFQ3: [],
  fieldPO: getDefaultPO(),
  currentStep: 1,
  'step-1': {
    index: 1,
    labelKey: 'rfq',
    componentName: 'main-rfq',
    isValid: false,
    showButton: true
  },
  'step-2': {
    index: 2,
    labelKey: 'add-parts',
    componentName: 'add-to-rfq-3',
    isValid: false,
    showButton: true
  },
  'step-3': {
    index: 3,
    labelKey: 'customer-quote',
    componentName: 'list-customer-quotes',
    isValid: false,
    showButton: true
  },
  'step-4': {
    index: 4,
    labelKey: 'create-po',
    componentName: 'po-form-rfq',
    isValid: false,
    showButton: true
  }
}

const getters = {
  stepList: (state) => {
    return stepIndexList
      .map((stepIndex) => (state[`step-${stepIndex}`]))
  },
  showedStepList: (state, getters) => {
    return getters['stepList'].filter(({ index }) => {
      return index <= state['currentStep']
    })
  },
  mapListRFQ3: (state) => {
    return state['listRFQ3'].reduce((result, item) => {
      result[item.rfqid + '__' + item.partID] = item
      return result
    }, {})
  }
}
const mutations = {
  SET,
  UPDATE,
  MERGE,
  PUSH,
  MERGE_ARRAY,
  DELETE_ITEM_ARRAY,
  MERGE_ITEM_ARRAY
}
const actions = {
  resetSteps ({ dispatch }) {
    return Promise.all(stepIndexList.map((stepIndex) => {
      let value = { isValid: false, showButton: true }
      return dispatch('changeStepData', { step: stepIndex, value })
    }))
  },
  checkMultipleRFQ3 ({ state, commit }, payload) {
    const { value, data } = payload
    const rfq3ID = data.id
    const newList = state.listRFQ3.map((item) => {
      let newItem = { ...item }
      newItem._includeMultiple = rfq3ID === item.id ? value : !!item._includeMultiple
      return newItem
    })

    commit('SET', { key: 'listRFQ3', value: newList })
    return Promise.resolve(newList)
  },
  resetState ({ commit, dispatch }) {
    return Promise.resolve()
      .then(() => {
        commit('SET', { key: 'dataRFQ', value: {} })
        commit('SET', { key: 'fieldPO', value: getDefaultPO() })
        commit('SET', { key: 'currentStep', value: 1 })
        commit('SET', { key: 'listRFQ1', value: [] })
        commit('SET', { key: 'listRFQ3', value: [] })
      })
      .then(() => {
        return dispatch('resetSteps')
      })
  },
  changeStepData ({ state, commit }, { step = 1, value = { } }) {
    return Promise
      .resolve()
      .then(() => {
        commit('MERGE', { key: `step-${step}`, value })
      })
  },
  setCurrentStep ({ commit }, { value = 1 }) {
    return Promise.resolve()
      .then(() => {
        commit('SET', { key: 'currentStep', value })
      })
  },
  createRFQ ({ commit }, data) {
    commit('SET', { key: 'isLoading', value: true })
    return ServiceRFQs.createRFQ(data)
      .then((response) => {
        commit('SET', { key: 'isLoading', value: false })
        commit('SET', { key: 'dataRFQ', value: response.data })
        return response.data
      })
      .catch((err) => {
        commit('SET', { key: 'isLoading', value: false })
        throw err
      })
  },
  createRFQ1 ({ commit }, data) {
    commit('SET', { key: 'isLoading', value: true })
    return api
      .post(`RFQ1s/Create`, data)
      .then(() => {
        commit('SET', { key: 'isLoading', value: false })
      })
      .catch((err) => {
        commit('SET', { key: 'isLoading', value: false })
        throw err
      })
  },
  createPO ({ commit }, data) {
    commit('SET', { key: 'isLoading', value: true })
    return ServiceRFQs.createPO(data)
      .then(() => {
        commit('MERGE', { key: 'dataRFQ', value: data })
        commit('SET', { key: 'isLoading', value: false })
      })
      .catch((err) => {
        commit('SET', { key: 'isLoading', value: false })
        throw err
      })
  },
  addRFQ1ToRFQ3 ({ commit }, data) {
    let _data = { ...data }
    delete _data.id
    commit('SET', { key: 'isLoading', value: true })
    return api
      .post(`RFQ3s/Create`, JSON.parse(JSON.stringify(_data)))
      .then((response) => {
        commit('SET', { key: 'isLoading', value: false })
      })
      .catch((err) => {
        commit('SET', { key: 'isLoading', value: false })
        throw err
      })
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
